import moment from 'moment';
import { ActionCellRenderer } from './_components/ActionCellRenderer';
import { styledDefaultColDef, createAvatarNameRenderer } from '../../../../extras/cellRenderers';

import ProgressBar from '../../_components/progress-bar/component';

import { useHistory } from 'react-router-dom';

const AvatarNameLink = createAvatarNameRenderer(
  (p) => p?.data?.firstName,
  (p) => p?.data?.lastName
);

const NameGetter = (params) => {
  const history = useHistory();

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', height: '100%', cursor: 'pointer' }}
      onClick={() => {
        history.push({
          pathname: '/all-users/user-details',
          state: { userParams: params.data },
        });
      }}
    >
      <AvatarNameLink {...params} />
    </div>
  );
};

const getFullName = (params) => {
  return params?.data?.firstName
    ? params?.data?.firstName + ' ' + params?.data?.lastName
    : params?.firstName
    ? params?.firstName + ' ' + params?.lastName
    : '';
};

// const RegDateGetter = (params) => {
//   return (
//     <div className='flex items-center relative top-2'>
//       {moment(params.data?.createdOn).utc().format('DD/MM/YYYY')}
//       <span className='text-gray-400 ml-2'>
//         ({moment(params.data?.createdOn).utc().fromNow()})
//       </span>
//     </div>
//   );
// };

export const columnDefs = [
  { field: 'id', width: 100 },
  {
    headerName: 'Name',
    field: 'name',
    filter: 'agTextColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['contains'],
      valueGetter: (props) => getFullName(props.data),
    },
    width: 200,

    valueGetter: (params) => {
      return getFullName(params);
    },

    cellRenderer: NameGetter,
  },
  {
    headerName: 'Mobile No',
    field: 'phone',
    width: 150,
    filter: 'agTextColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals'],
    },
    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>{params?.data?.phone}</div>
      );
    },
  },
  {
    headerName: 'Phone Verified',
    field: 'isPhoneVerified',
    width: 150,
    cellRenderer: (params) => {
      const verified = params?.data?.isPhoneVerified;
      if (verified === undefined || verified === null) return null;
      return (
        <div className='flex items-center h-full'>
          {verified ? (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: '#2563EB' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#2563EB"/><path d="M4 7L6 9.5L10 5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
              Verified
            </span>
          ) : (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 12, fontWeight: 600, color: '#9CA3AF' }}>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#D1D5DB"/><path d="M4.5 4.5L9.5 9.5M9.5 4.5L4.5 9.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/></svg>
              Unverified
            </span>
          )}
        </div>
      );
    },
  },
  {
    headerName: 'Email',
    field: 'email',
    width: 300,

    filter: 'agTextColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals'],
      valueGetter: (props) => getFullName(props.data),
    },
    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>{params?.data?.email}</div>
      );
    },
  },
  {
    headerName: 'Signup Date',
    field: 'signupDate',
    width: 140,

    filter: 'agDateColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals', 'greaterThan'],
    },

    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>
          {params?.data?.createdOn
            ? moment(params?.data?.createdOn).format('DD MMM YYYY')
            : '-'}
        </div>
      );
    },
  },
  {
    headerName: 'Enrollment Date',
    field: 'enrollmentDate',
    width: 160,

    filter: 'agDateColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals', 'greaterThan'],
    },

    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>
          {params?.data?.UserSubscriptions_createdOn
            ? moment(params?.data?.UserSubscriptions_createdOn).format(
                'DD MMM YYYY'
              )
            : '-'}
        </div>
      );
    },
  },
  {
    headerName: 'Plan Type',
    field: 'planType',
    width: 120,

    filter: 'agSetColumnFilter',
    filterParams: {
      values: ['pro_live', 'pro_flex', 'masters'],
    },
    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>
          {params?.data?.UserSubscriptions_planType}
        </div>
      );
    },
  },
  {
    headerName: 'Course Type',
    field: 'courseType',
    width: 130,

    filter: 'agSetColumnFilter',
    filterParams: {
      values: ['data-science', 'data-engineering', 'web3', 'ug-diploma-cs'],
    },
    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>
          {params?.data?.UserSubscriptions_courseType}
        </div>
      );
    },
  },
  {
    headerName: 'Sub Plan Type',
    field: 'UserSubscriptions_subPlanType',
  },
  {
    headerName: 'Progress',
    field: 'courseProgress',
    width: 200,

    filter: 'agNumberColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['equals', 'greaterThan', 'lessThan'],
    },

    cellRenderer: (params) => {
      return (
        <div className='flex items-center justify-center h-full w-48 min-w-full'>
          <ProgressBar
            progress={(params?.data?.course_progress || 0) / 100}
            bold={true}
            width='90px'
          />
        </div>
      );
    },
  },
  {
    headerName: 'Fee Paid',
    field: 'feePaid',
    width: 130,

    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>
          {(params?.data?.UserSubscriptions_amount / 100).toLocaleString(
            'en-IN',
            {
              maximumFractionDigits: 2,
              style: 'currency',
              currency: 'INR',
            }
          )}
        </div>
      );
    },
  },
  {
    headerName: 'Cohort Name',
    field: 'cohort',
    width: 180,
    valueGetter: (params) => params?.data?.UserSubscriptions_cohortName,

    filter: 'agTextColumnFilter',
    filterParams: {
      suppressAndOrCondition: true,
      filterOptions: ['contains'],
    },
    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>
          {params?.data?.UserSubscriptions_cohortName}
        </div>
      );
    },
  },

  {
    headerName: 'AlmaX Cohort Name',
    field: 'almaXCohort',
    width: 180,

    filter: 'agSetColumnFilter',
    filterParams: {
      values: ['SSP', 'ProX'],
    },
    cellRenderer: (params) => {
      return (
        <div className='flex items-center h-full'>
          {params?.data?.UserSubscriptions_almaxCohortName}
        </div>
      );
    },
  },

  {
    headerName: 'Status',
    field: 'status',
    width: 120,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: ['Active', 'Archived'],
    },
    cellRenderer: (params) => {
      const status = params.data.status || 'Active';
      const color = status === 'Active' ? '#4CAF50' : '#F44336';
      return (
        <div className='flex items-center justify-center h-full'>
          <span
            style={{
              color,
              fontWeight: 600,
              padding: '4px 12px',
              borderRadius: '4px',
              backgroundColor: `${color}20`,
              fontSize: '12px',
            }}
          >
            {status}
          </span>
        </div>
      );
    },
  },

  {
    headerName: 'Actions',
    pinned: 'right',
    sortable: false,
    suppressMenu: true,
    width: 100,
    cellRenderer: ActionCellRenderer,
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  filter: false,
  sortable: false,
};
